import Alpine from 'alpinejs';
import autoComplete from '@tarekraafat/autocomplete.js';

Alpine.data('autocomplete', () => ({
    url: '',
    valueKey: '',
    textKey: '',

    init() {
        const dataset = this.$el.dataset;

        this.url = dataset.autocompleteUrl || '';
        this.valueKey = dataset.autocompleteValue || '';
        this.textKey = dataset.autocompleteText || '';

        new autoComplete({
            selector: () => this.$el,
            debounce: 300,
            data: {
                src: async (query) => {
                    const
                        url = this.url + `&s=${query}`,
                        source = await fetch(url);

                    return await source.json();
                },
                keys: [this.textKey]
            },
            trigger: (query) => query.replace(/ /g, "").length,
            resultsList: {
                class: 'absolute w-sm max-w-sm max-h-56 overflow-y-auto bg-neutral-primary-medium border border-default-medium rounded-base shadow-lg text-sm text-body font-medium p-2 z-10'
            },
            resultItem: {
                class: 'cursor-pointer hover:bg-neutral-tertiary-medium hover:text-heading [&[aria-selected]]:bg-neutral-tertiary-medium rounded px-4 py-2',
                highlight: true
            },
            events: {
                input: {
                    selection: ({ detail, target }) => {
                        const value = detail.selection.value;
                        target.value = value[this.valueKey];

                        this.$dispatch('selected', value);
                    }
                }
            }
        });
    }
}));
